import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'

const routes = [
  // Dashboards
  {
    path: '/dashboard',
    Component: lazy(() => import('pages/dashboard')),
    exact: true,
  },

  // Files
  {
    path: '/files',
    Component: lazy(() => import('pages/files')),
    exact: true,
  },
  {
    path: '/files/detail/:id',
    Component: lazy(() => import('pages/files/detail')),
    exact: true,
  },

  // Profil
  {
    path: '/profile',
    Component: lazy(() => import('pages/profile')),
    exact: true,
  },

  // Calendar
  {
    path: '/calendar',
    Component: lazy(() => import('pages/calendar')),
    exact: true,
  },

  // On Boarding
  {
    path: '/onboarding',
    Component: lazy(() => import('pages/auth/onboarding')),
    exact: true,
  },

  // Mail
  {
    path: '/mail/validation/:userId/:token',
    Component: lazy(() => import('pages/mail/emailValidation')),
    exact: true,
  },

  // HelpDesk
  {
    path: '/helpdesk',
    Component: lazy(() => import('pages/apps/helpdesk-dashboard')),
    exact: true,
  },

  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => (
  <ConnectedRouter history={history}>
    <Layout>
      <Route
        render={(state) => {
          const { location } = state
          return (
            <SwitchTransition>
              <CSSTransition
                key={location.pathname}
                appear
                classNames={routerAnimation}
                timeout={routerAnimation === 'none' ? 0 : 300}
              >
                <Switch location={location}>
                  <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
                  {routes.map(({ path, Component, exact }) => (
                    <Route
                      path={path}
                      key={path}
                      exact={exact}
                      render={() => (
                        <div className={routerAnimation}>
                          <Suspense fallback={null}>
                            <Component />
                          </Suspense>
                        </div>
                      )}
                    />
                  ))}
                  <Redirect to="/auth/404" />
                </Switch>
              </CSSTransition>
            </SwitchTransition>
          )
        }}
      />
    </Layout>
  </ConnectedRouter>
)

export default connect(mapStateToProps)(Router)
